<template>
  <SearchFormWrapper>
    <form
      autocomplete="off"
      class="flex items-center gap-2 h-10 [&>*]:h-full [&_input]:h-full"
      @submit.prevent="$emit('search', JSON.parse(JSON.stringify(searchParams)))"
    >
      <SearchQueryTextInput
        v-model="searchParams.search"
        :placeholder="placeholder"
        @clear="handleClear"
      />

      <SwitchInputWrapper v-if="archiveable">
        <SwitchInput
          v-model="searchParams.includeArchived"
          text="Show Archived"
        />
      </SwitchInputWrapper>

      <SearchButton :btn-class="btnClass" />
    </form>
  </SearchFormWrapper>
</template>

<script setup>
import { ref } from 'vue';
import { SearchFormWrapper } from '@/components/forms';
import { SearchButton } from '@/components/buttons';
import { SearchQueryTextInput, SwitchInput } from '@/components/form-inputs';
import { SwitchInputWrapper } from '@/components/wrappers';

const emit = defineEmits(['search']);

const props = defineProps({
  archiveable: {
    type: Boolean,
    default: true,
  },
  placeholder: {
    type: String,
    default: 'Search',
  },
  btnClass: {
    type: String,
    default: 'btn-outline btn-primary rounded',
  },
});

const searchParams = ref({
  search: null,
  ...(props.archiveable && { includeArchived: false }),
});

function handleClear() {
  emit('search', JSON.parse(JSON.stringify(searchParams.value)));
}
</script>
